module.exports = __webpack_public_path__ + "static/hot-application-6c576941d307e45200edb4039d60a437.png";